
    import Vue from "vue";
    import Component from "vue-class-component";
    import eventBus from "./utilities/EventBus";
    import { ApiClient, ISendRequestParameters } from "./utilities/ApiClient";
    import * as toastr from "toastr";
    import SignInDialogue from "./components/SignInDialogue.vue";
    import ErrorMessage from "./components/ErrorMessage.vue";

    const defaultLayout = "signed-out";

    @Component({
        components: { SignInDialogue, ErrorMessage }
    })
    export default class App extends Vue {

        private pendingApiParameters: ISendRequestParameters | null = null;

        private errorMessageOptions = {
            shouldShow: false,
            title: "",
            message: "",
            icon: "",
            extraContent: ""
        }

        mounted() {

            // Prevent any XSS shenanigans by default
            toastr.options.escapeHtml = true;

            eventBus.$on("http-401", (parameters: ISendRequestParameters) => {
                this.pendingApiParameters = parameters;
                console.log("...App component - setting promise and showing login dialogue");
                const dlg: SignInDialogue = this.$refs.signInDialogue as SignInDialogue;
                dlg.show();
            });

            eventBus.$on("http-error", (response: Response) => {
                const contentType = response.headers.get("Content-Type");
                const status = response.status;
                if (status === 500) {
                    response.text().then(bodyText => {
                        // if we're running in production, we'll probably not get a response body - but handy to show in dev mode
                        if (bodyText) {
                            this.showErrorMessageWithContent("Server Error", "Status = " + response.status, bodyText);
                        }
                        else {
                            this.showErrorMessage("Server Error", "Status = " + response.status);
                        }
                    });
                }
                else {
                    this.showErrorMessage("HTTP Error", "Status = " + response.status);
                }
            });

            eventBus.$on("fetch-exception", (reason: any) => {
                console.log("here 1")
                const message = typeof reason === "string"
                    ? reason
                    : (typeof reason === "object" && reason.message)
                        ? reason.message
                        : "Failed to communicate with server";
                this.showErrorMessage("API Error", message, "fas fa-exclamation-circle fa-lg");
            });

            eventBus.$on("fetch-failed-offline", () => {
                console.log("here 2")

                this.showErrorMessage("Network Problem", "Could not communicate with server.\n\nPlease check your network connection.", "fas fa-exclamation-circle fa-lg");
            });
        }

        onAuthenticated() {
            console.log("...App component - onAuthenticated");
            if (this.pendingApiParameters == null) {
                console.log("...App component - onAuthenticated - pendingApiParameters is **NULL**!");
                // what should we do if we ever get here?!!
                return;
            }
            console.log("...App component - resend last API request");
            ApiClient.sendRequest(this.pendingApiParameters);
            this.pendingApiParameters = null;
        }

        showErrorMessageWithContent(title: string, message: string, content: string) {
            const ce = this.$createElement;

            const messageVNode = ce('div', {}, [
                ce('div', { class: ['errorMessageContainer'] }, [
                    ce('div', { class: ['fas fa-bomb errorMessageIcon'] }, []),
                    ce('div', { class: ['errorMessageText'] }, [message])
                ]),
                ce('div', { class: ['errorMessageContent'] }, [content])
            ]);

            this.$bvModal.msgBoxOk([messageVNode], {
                title: title,
                size: "xl",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "dismiss",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            });
            // .then(value => { })
            // .catch(err => { });
        }

        showErrorMessage(title: string, message: string, icon?: string, content?: string) {
            this.errorMessageOptions.shouldShow = true;
            this.errorMessageOptions.title = title;
            this.errorMessageOptions.message = message;
            this.errorMessageOptions.icon = icon ?? "fas fa-exclamation-circle fa-lg";
            if (content) this.errorMessageOptions.extraContent = content;
        }

        // computed property used to select layout - see also main.ts
        get layout() {
            if (!this.$route?.meta?.layout) return null;
            return (this.$route.meta.layout || defaultLayout) + "-layout";
        }
    }
